import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { FormGroup, TextInputForm } from '@udemy-v2/react-form-components';
import { useI18n } from '@udemy-v2/i18n';
import React from 'react';
interface SearchWidgetProps {
  onSubmit: (value: string) => void;
  onClear: () => void;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  size?: 'small' | 'medium';
  submitButtonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
}
export const SearchWidget = t0 => {
  const $ = _c(28);
  const {
    onSubmit,
    onClear,
    value,
    onChange,
    size: t1,
    submitButtonProps: t2
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const submitButtonProps = t3;
  const {
    gettext
  } = useI18n();
  let t4;
  if ($[2] !== onClear || $[3] !== onSubmit || $[4] !== value) {
    t4 = event => {
      event.preventDefault();
      const searchTerm = value.trim();
      if (!searchTerm) {
        onClear();
      } else {
        onSubmit(searchTerm);
      }
    };
    $[2] = onClear;
    $[3] = onSubmit;
    $[4] = value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleFormSubmit = t4;
  const showClear = value !== "";
  let t5;
  if ($[6] !== gettext) {
    t5 = gettext("Search reviews");
    $[6] = gettext;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      className: "ud-sr-only"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== gettext) {
    t7 = gettext("Submit search");
    $[9] = gettext;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <Icon glyph="search" label={t7} />;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== gettext) {
    t9 = gettext("Search reviews");
    $[13] = gettext;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== handleFormSubmit || $[16] !== onChange || $[17] !== onClear || $[18] !== showClear || $[19] !== size || $[20] !== submitButtonProps || $[21] !== t8 || $[22] !== t9 || $[23] !== value) {
    t10 = <TextInputForm submitButtonContent={t8} submitButtonProps={submitButtonProps} onChange={onChange} onClearInput={onClear} onSubmit={handleFormSubmit} size={size} placeholder={t9} showClearInputButton={showClear} value={value} />;
    $[15] = handleFormSubmit;
    $[16] = onChange;
    $[17] = onClear;
    $[18] = showClear;
    $[19] = size;
    $[20] = submitButtonProps;
    $[21] = t8;
    $[22] = t9;
    $[23] = value;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t5) {
    t11 = <FormGroup label={t5} labelProps={t6} className="">{t10}</FormGroup>;
    $[25] = t10;
    $[26] = t5;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};